import * as React from 'react'

export const filterSingleCheckbox = (label: string) => {
  return (
    <li className="fo__item">
      <label htmlFor={label} className="fo__label">
        <span className="fo__label-copy text--m">{label}</span>
        <input className="fo__checkbox" type="checkbox" name={label} id={label} />
      </label>
    </li>
  )
}

export const filterCheckboxesList = () => {
  return (
    <li className="fo__items">
      <h3 className="fo__section text--m">Fringilla</h3>
      <ul className="fo__list">
        {filterSingleCheckbox('Quam Cras')}
        {filterSingleCheckbox('Nibh Quam')}
        {filterSingleCheckbox('Justo Sollicitudin')}
        {filterSingleCheckbox('Quam Inceptos')}
        <button className="fo__toggle link link--secondary">Show more</button>
      </ul>
    </li>
  )
}


export const filtersOverlay = () => {
  return (
    <>
      <button className='button button--filter' 
        onClick={() => toggleFilters()}
      >
        <span>Filter</span>
        <svg aria-hidden="true" width={32} height={30}><use xlinkHref="#icon--filter" /></svg>
      </button>
      <div className="filter-overview fo fo--hidden">
        <div className="fo__inner grid--block">
          <button className="fo__button"
            onClick={() => toggleFilters()}
          >
            <span className="sr-text">Closing overlay button</span>
            <svg className="fo__button--icon" aria-hidden="true" height="30" width="32">
              <use xlinkHref="#icon--close-circled" />
            </svg>
          </button>
          <h2 className="fo__title title--xs">Filter</h2>
          <form className="fo__form">
            <ul className="fo__lists">
              {filterCheckboxesList()}
              {filterCheckboxesList()}
              {filterCheckboxesList()}
              {filterCheckboxesList()}
              {filterCheckboxesList()}
            </ul>
            <div className="fo__bottom">
              <div className="fo__icon"></div>
              <div className="fo__actions">
                <button className="button button--primary">Show vacancies</button>
                <button className="link link--secondary">Reset filters</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

function toggleFilters() {
  const filterOverlay : HTMLElement = document.querySelector('.fo')
  if(!filtersOverlay) return;

  if(filterOverlay.classList.contains('fo--hidden')) {
    filterOverlay.classList.remove('fo--hidden')
    // document.documentElement.style.overflowY = "hidden"
  } else {
    filterOverlay.classList.add('fo--hidden')
    document.documentElement.classList.remove('nav--toggled')
    // document.documentElement.style.overflowY = "auto"
  }
}
